import { render, staticRenderFns } from "./page_solution.vue?vue&type=template&id=f5a314be&scoped=true"
import script from "./page_solution.vue?vue&type=script&lang=js"
export * from "./page_solution.vue?vue&type=script&lang=js"
import style0 from "./page_solution.vue?vue&type=style&index=0&id=f5a314be&prod&lang=less"
import style1 from "./page_solution.vue?vue&type=style&index=1&id=f5a314be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a314be",
  null
  
)

export default component.exports